/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */

import { environment } from "../../../../environments/environments";

export class NotificationsService {
  private readonly notificationCountUrl = environment.notificationsCount;

  public window: Window;

  public constructor(window: Window) {
    this.window = window;
  }

  public async getNotificationsCount(): Promise<{
    notificationsCount: number;
  }> {
    try {
      const response = await this.window.fetch(this.notificationCountUrl, {
        method: "GET",
        headers: {
          accept: "application/json",
        },
        cache: "no-cache",
        mode: "cors",
        credentials: "include",
        referrerPolicy: "no-referrer",
      });
      if (response.status !== 200) {
        throw new Error(
          `Fetch failed with ${response.status} status code. Details: ${response.statusText}`
        );
      }
      return await response.json();
    } catch (e) {
      console.error("Failed to fetch notifications count", e);
      throw e;
    }
  }
}
